import _axios from "../../libs/axios";
import { NotificationManager } from "../../components/common/react-notifications";
export default (context) => {
  let columns = [
    {
      Header: "Cliente",
      accessor: "name"
    },
    {
      Header: "Monto",
      accessor: "total",
      isDecimal: true,
      minWidth: 70
    },
    {
      Header: "Monto recibo",
      accessor: "amountReceipt",
      isDecimal: true,
      minWidth: 70
    },
    {
      Header: "Mora",
      accessor: "penalty",
      isDecimal: true,
      minWidth: 70
    },
    {
      Header: "Fecha",
      accessor: "date",
      isDate: true
    },
    {
      Header: "Dependiente",
      accessor: "depend"
    },
    {
      Header: "Documento",
      accessor: "dependDoc"
    },
    {
      Header: "Detalle",
      accessor: "det",
      minWidth: 200
    },
    {
      Header: "Tarjeta",
      accessor: "card",
      minWidth: 70
    },
    {
      Header: "Num. Oper.",
      accessor: "opnum",
      minWidth: 70
    },
    {
      Header: "Código Externo",
      accessor: "externalId"
    },
    {
      Header: "Referencia",
      accessor: "note"
    }
  ]

  let extras = null

  if (window.location.href.includes('admBilling')) extras = {
    items: [
      {
        icon: 'simple-icon-credit-card',
        name: 'Cobros automáticos',
        onClick: (ctx) => {
          // Get today's date in YYYY-M-D format
          const today = new Date();
          const formattedDate = `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`;

          // Function to handle automatic charge
          const handleAutomaticCharge = () => {
            ctx.props.setLoader(true);
            _axios.post(`admBilling/automaticCharge/${formattedDate}?confirm=true`)
              .then(r => {
                ctx.props.setLoader(false);
                NotificationManager[r.status >= 0 ? 'success' : 'error'](r.msg, r.status >= 0 ? '' : 'Opps', 5000, null, null, 'outline');
                ctx.toggleRight();
              })
          };

          // Prepare the right panel content using FormSmart with custom detailGrid
          ctx.setState({
            modalRightContent: {
              name: "Cobros automáticos",
              fields: [],
              buttons: [
                {
                  label: "Iniciar cobros ahora",
                  icon: 'simple-icon-credit-card',
                  onClick: handleAutomaticCharge
                }
              ],
              detailGrid: () => ({
                module: 'admBilling',
                embeded: () => ({
                  config: {
                    pageSize: 100,
                    customPathGet: `admBilling/automaticCharge/${formattedDate}`,
                    customTitle: 'Cobros automáticos a realizarse hoy',
                  },
                  actions: {
                    create: false,
                    edit: false,
                    delete: false,
                    print: false,
                    export: false,
                    search: false
                  },
                  columns: [
                    {
                      Header: "main.ID",
                      accessor: "ID",
                      hidden: true
                    },
                    { Header: "Cuota", accessor: "content" },
                    { Header: "Fecha vencimiento", accessor: "date", isDate: true }
                  ]
                })
              })
            }
          }, ctx.toggleRight);
        }
      }
    ]
  }

  if(window.location.href.includes('admOrder'))  columns = columns.filter(e => !['name','depend'].includes(e.accessor))
  
  return {
    config: {
      pageSize: 40,
      list: false,
      remap: r => {
        if (r.status > -1) r.data.Results.map(e => e.amountReceipt = (e.total - e.penalty))
        return r
      }
    },

    actions: {
      create: false,
      edit: false,
      delete: false,
      print: {remap: true},
      export: {remap: true},
      search: window.location.href.includes('admBilling')
    },

    filter: {
      fields: [
        {
          name: "studentId",
          value: "",
          type: "select",
          label: "Alumno",
          opts: {
            style: 'float-label',
            searchOnline: true,
            path: "/admStudent/get?enrolled=-1&pick=true",
            withImg: true
          },
          renderIf: (ctx) => { return window.location.href.includes('admBilling') }
        },
        {
          type: "daterange",
          range: {
            value: 1,
            renderIf: () => window.location.href.includes('admBilling')
          },
          from: {
            renderIf: ctx => window.location.href.includes('admBilling') && ctx.state.range === 2
          },
          to: {
            renderIf: ctx => window.location.href.includes('admBilling') && (ctx.state.range === 2 && ctx.state.from)
          }
        },
        {
          name: "status",
          value: "",
          type: "select",
          label: "Estado",
          opts: {
            style: 'float-label',
            items: [
              {
                value: 1,
                label: "Confirmados"
              },
              {
                value: 0,
                label: "Pendientes"
              },
              {
                value: -1,
                label: "Abandonados"
              },
              {
                value: -2,
                label: "Con error"
              },
            ]
          },
          renderIf: (ctx) => { return window.location.href.includes('admBilling') }
        },
        {
          name: "type",
          value: "",
          type: "select",
          label: "Tipo",
          opts: {
            style: 'float-label',
            items: [
              { value: 0, label: "CARD" },
              { value: 3, label: "BANK" },
              { value: 4, label: "TRANSFER" },
              { value: 5, label: "CASH - DEPOSIT" },
              { value: 2, label: "CASH - OTHER" },
              { value: 6, label: "CARD SUBSCRIPTION" }
            ]
          },
          renderIf: () => window.location.href.includes('admBilling')
        },
      ],
      buttons: [
        {
          label: 'Aplicar filtro',
          renderIf: (ctx) => { return ctx.state.from || ctx.state.to || Number.isInteger(ctx.state.status) || Number.isInteger(ctx.state.studentId || ctx.state.type)},
          onClick: (ctx) => { ctx.btnAction('filter') }
        }
      ]
    },

    columns: columns,

    extras: extras
  }
}